/**
 * Base TTS Provider Interface
 * Defines the contract that all TTS providers must implement
 */

export interface ITTSProvider {
  /**
   * Generate audio blob from text
   * @param text Text to convert to speech
   * @returns Promise that resolves to audio blob
   */
  generateAudio(text: string): Promise<Blob>;

  /**
   * Get provider name for logging/debugging
   */
  getProviderName(): string;

  /**
   * Optional cleanup method
   */
  destroy?(): void;
}

export abstract class BaseTTSProvider implements ITTSProvider {
  protected config: any;

  constructor(config: any) {
    this.config = config;
  }

  abstract generateAudio(text: string): Promise<Blob>;
  
  abstract getProviderName(): string;

  destroy(): void {
    // Default implementation - providers can override if needed
  }

  /**
   * Clean text by removing action brackets and normalizing whitespace
   */
  protected cleanText(text: string): string {
    return text
      .replace(/\[.*?\]/g, '') // Remove action brackets
      .replace(/\s+/g, ' ')    // Normalize whitespace
      .trim();
  }

  /**
   * Validate that text is not empty after cleaning
   */
  protected validateText(text: string): string {
    const cleaned = this.cleanText(text);
    if (!cleaned) {
      throw new Error('No text to synthesize after cleaning');
    }
    return cleaned;
  }
}